import { Typography } from "@foodpilot/foods";
import { Stack, Box, useTheme, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useActionsContext } from "src/context/Actions/useActionsContext";

type TabHeaderProps = {
    title: string;
    showOnMobile?: boolean;
};
export const TabHeader = (props: TabHeaderProps) => {
    const { title, showOnMobile = false } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    const { actionPlan, isFetched } = useActionsContext();

    const startingCampaign = actionPlan?.startSsqPost.campaign?.label;

    return (
        <Stack
            flexDirection={"row"}
            alignItems="center"
            gap={theme.spacing(2)}
            minWidth={0}
            flexWrap={{ xs: showOnMobile ? "wrap" : "nowrap", md: "nowrap" }}
            sx={{
                [theme.breakpoints.down("md")]: {
                    display: showOnMobile ? "flex" : "none",
                },
            }}
        >
            <Box minWidth={0} maxWidth="100%" sx={{ overflowWrap: "anywhere" }}>
                <Typography variant="h2">{title}</Typography>
            </Box>
            <Box
                sx={{
                    height: theme.spacing(5),
                    borderLeft: 1,
                    borderColor: theme.custom.grey[500],
                    display: { xs: "none", md: "block" },
                }}
            />
            {isFetched ?
                <Stack
                    flexDirection={"row"}
                    flexWrap={{ xs: "wrap", md: "nowrap" }}
                    minWidth={0}
                    gap={theme.spacing(0.5)}
                    alignItems={"center"}
                >
                    <Typography variant="body">{t("glossary.from", "From")}</Typography>
                    <Typography variant="body-bold">{startingCampaign}</Typography>
                    <Typography variant="body">{t("glossary.to", "to")}</Typography>
                    <Typography variant="body-bold">{actionPlan?.endCampaign?.label ?? ""}</Typography>
                </Stack>
            :   <CircularProgress size={25} />}
        </Stack>
    );
};
